import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShadowOverlayComponent } from './shadow-overlay.component';

@NgModule({
  declarations: [ShadowOverlayComponent],
  imports: [CommonModule],
  exports: [ShadowOverlayComponent],
})
export class ShadowOverlayModule {}
